// Auto-generated from ateco-codes-it.json — do not edit manually
// To regenerate: node scripts/generate-valid-ateco-codes.mjs

const validAtecoCodesSet = new Set<string>([
  '01',
  '02',
  '03',
  '05',
  '06',
  '07',
  '08',
  '09',
  '10',
  '11',
  '011',
  '12',
  '012',
  '13',
  '013',
  '14',
  '014',
  '15',
  '015',
  '16',
  '016',
  '17',
  '017',
  '18',
  '19',
  '20',
  '21',
  '021',
  '22',
  '022',
  '23',
  '023',
  '24',
  '024',
  '25',
  '26',
  '27',
  '28',
  '29',
  '30',
  '31',
  '031',
  '32',
  '032',
  '33',
  '033',
  '35',
  '36',
  '37',
  '38',
  '39',
  '41',
  '42',
  '43',
  '46',
  '47',
  '49',
  '50',
  '51',
  '051',
  '52',
  '052',
  '53',
  '55',
  '56',
  '58',
  '59',
  '60',
  '61',
  '061',
  '62',
  '062',
  '63',
  '64',
  '65',
  '66',
  '68',
  '69',
  '70',
  '71',
  '071',
  '72',
  '072',
  '73',
  '74',
  '75',
  '77',
  '78',
  '79',
  '80',
  '81',
  '081',
  '82',
  '84',
  '85',
  '86',
  '87',
  '88',
  '089',
  '90',
  '91',
  '091',
  '92',
  '93',
  '94',
  '95',
  '96',
  '97',
  '98',
  '99',
  '099',
  '101',
  '102',
  '103',
  '104',
  '105',
  '106',
  '107',
  '108',
  '109',
  '110',
  '0111',
  '0112',
  '0113',
  '0114',
  '0115',
  '0116',
  '0119',
  '120',
  '0121',
  '0122',
  '0123',
  '0124',
  '0125',
  '0126',
  '0127',
  '0128',
  '0129',
  '0130',
  '131',
  '132',
  '133',
  '139',
  '141',
  '0141',
  '142',
  '0142',
  '0143',
  '0144',
  '0145',
  '0146',
  '0147',
  '0148',
  '0150',
  '151',
  '152',
  '161',
  '0161',
  '162',
  '0162',
  '0163',
  '0170',
  '171',
  '172',
  '181',
  '182',
  '191',
  '192',
  '201',
  '202',
  '203',
  '204',
  '205',
  '206',
  '0210',
  '211',
  '212',
  '0220',
  '221',
  '222',
  '0230',
  '231',
  '232',
  '233',
  '234',
  '235',
  '236',
  '237',
  '239',
  '0240',
  '241',
  '242',
  '243',
  '244',
  '245',
  '251',
  '252',
  '253',
  '254',
  '255',
  '256',
  '259',
  '261',
  '262',
  '263',
  '264',
  '265',
  '266',
  '267',
  '271',
  '272',
  '273',
  '274',
  '275',
  '279',
  '281',
  '282',
  '283',
  '284',
  '289',
  '291',
  '292',
  '293',
  '301',
  '302',
  '303',
  '304',
  '309',
  '310',
  '0311',
  '0312',
  '321',
  '0321',
  '322',
  '0322',
  '323',
  '324',
  '325',
  '329',
  '0330',
  '331',
  '332',
  '351',
  '352',
  '353',
  '354',
  '360',
  '370',
  '381',
  '382',
  '383',
  '390',
  '410',
  '421',
  '422',
  '429',
  '431',
  '432',
  '433',
  '434',
  '435',
  '436',
  '439',
  '461',
  '462',
  '463',
  '464',
  '465',
  '466',
  '467',
  '468',
  '469',
  '471',
  '472',
  '473',
  '474',
  '475',
  '476',
  '477',
  '478',
  '479',
  '491',
  '492',
  '493',
  '494',
  '495',
  '501',
  '502',
  '503',
  '504',
  '0510',
  '511',
  '512',
  '0520',
  '521',
  '522',
  '523',
  '531',
  '532',
  '533',
  '551',
  '552',
  '553',
  '554',
  '559',
  '561',
  '562',
  '563',
  '564',
  '581',
  '582',
  '591',
  '592',
  '601',
  '602',
  '603',
  '0610',
  '611',
  '612',
  '619',
  '0620',
  '621',
  '622',
  '629',
  '631',
  '639',
  '641',
  '642',
  '643',
  '649',
  '651',
  '652',
  '653',
  '661',
  '662',
  '663',
  '681',
  '682',
  '683',
  '691',
  '692',
  '701',
  '702',
  '0710',
  '711',
  '712',
  '721',
  '0721',
  '722',
  '0729',
  '731',
  '732',
  '733',
  '741',
  '742',
  '743',
  '749',
  '750',
  '771',
  '772',
  '773',
  '774',
  '775',
  '781',
  '782',
  '791',
  '799',
  '800',
  '811',
  '0811',
  '812',
  '0812',
  '813',
  '821',
  '822',
  '823',
  '824',
  '829',
  '841',
  '842',
  '843',
  '851',
  '852',
  '853',
  '854',
  '855',
  '856',
  '861',
  '862',
  '869',
  '871',
  '872',
  '873',
  '879',
  '881',
  '889',
  '0891',
  '0892',
  '0893',
  '0899',
  '901',
  '902',
  '903',
  '0910',
  '911',
  '912',
  '913',
  '914',
  '920',
  '931',
  '932',
  '941',
  '942',
  '949',
  '951',
  '952',
  '953',
  '954',
  '961',
  '962',
  '963',
  '964',
  '969',
  '970',
  '981',
  '982',
  '990',
  '0990',
  '1011',
  '1012',
  '1013',
  '1020',
  '1031',
  '1032',
  '1039',
  '1041',
  '1042',
  '1051',
  '1052',
  '1061',
  '1062',
  '1071',
  '1072',
  '1073',
  '1081',
  '1082',
  '1083',
  '1084',
  '1085',
  '1086',
  '1089',
  '1091',
  '1092',
  '1101',
  '1102',
  '1103',
  '1104',
  '1105',
  '1106',
  '1107',
  '01110',
  '01120',
  '01131',
  '01132',
  '01133',
  '01140',
  '01150',
  '01160',
  '01191',
  '01199',
  '1200',
  '01210',
  '01220',
  '01230',
  '01240',
  '01250',
  '01260',
  '01270',
  '01280',
  '01290',
  '01300',
  '1310',
  '1320',
  '1330',
  '1391',
  '1392',
  '1393',
  '1394',
  '1395',
  '1396',
  '1399',
  '1410',
  '01410',
  '01420',
  '1421',
  '1422',
  '1423',
  '1424',
  '1429',
  '01430',
  '01440',
  '01450',
  '01460',
  '01470',
  '01481',
  '01482',
  '01483',
  '01484',
  '01489',
  '01500',
  '1511',
  '1512',
  '1520',
  '1611',
  '01611',
  '1612',
  '01619',
  '01620',
  '1621',
  '1622',
  '1623',
  '1624',
  '1625',
  '1626',
  '1627',
  '1628',
  '01631',
  '01632',
  '01700',
  '1711',
  '1712',
  '1721',
  '1722',
  '1723',
  '1724',
  '1725',
  '1811',
  '1812',
  '1813',
  '1814',
  '1820',
  '1910',
  '1920',
  '2011',
  '2012',
  '2013',
  '2014',
  '2015',
  '2016',
  '2017',
  '2020',
  '2030',
  '2041',
  '2042',
  '2051',
  '2059',
  '2060',
  '02100',
  '2110',
  '2120',
  '02200',
  '2211',
  '2212',
  '2221',
  '2222',
  '2223',
  '2224',
  '2225',
  '2226',
  '02300',
  '2311',
  '2312',
  '2313',
  '2314',
  '2315',
  '2320',
  '2331',
  '2332',
  '2341',
  '2342',
  '2343',
  '2344',
  '2345',
  '2351',
  '2352',
  '2361',
  '2362',
  '2363',
  '2364',
  '2365',
  '2366',
  '2370',
  '2391',
  '2399',
  '02400',
  '2410',
  '2420',
  '2431',
  '2432',
  '2433',
  '2434',
  '2441',
  '2442',
  '2443',
  '2444',
  '2445',
  '2446',
  '2451',
  '2452',
  '2453',
  '2454',
  '2511',
  '2512',
  '2521',
  '2522',
  '2530',
  '2540',
  '2551',
  '2552',
  '2553',
  '2561',
  '2562',
  '2563',
  '2591',
  '2592',
  '2593',
  '2594',
  '2599',
  '2611',
  '2612',
  '2620',
  '2630',
  '2640',
  '2651',
  '2652',
  '2660',
  '2670',
  '2711',
  '2712',
  '2720',
  '2731',
  '2732',
  '2733',
  '2740',
  '2751',
  '2752',
  '2790',
  '2811',
  '2812',
  '2813',
  '2814',
  '2815',
  '2821',
  '2822',
  '2823',
  '2824',
  '2825',
  '2829',
  '2830',
  '2841',
  '2842',
  '2891',
  '2892',
  '2893',
  '2894',
  '2895',
  '2896',
  '2897',
  '2899',
  '2910',
  '2920',
  '2931',
  '2932',
  '3011',
  '3012',
  '3013',
  '3020',
  '3031',
  '3032',
  '3040',
  '3091',
  '3092',
  '3099',
  '3100',
  '03110',
  '03120',
  '03210',
  '3211',
  '3212',
  '3213',
  '3220',
  '03220',
  '3230',
  '3240',
  '3250',
  '3291',
  '3299',
  '03300',
  '3311',
  '3312',
  '3313',
  '3314',
  '3315',
  '3316',
  '3317',
  '3318',
  '3319',
  '3320',
  '3511',
  '3512',
  '3513',
  '3514',
  '3515',
  '3516',
  '3521',
  '3522',
  '3523',
  '3524',
  '3530',
  '3540',
  '3600',
  '3700',
  '3811',
  '3812',
  '3821',
  '3822',
  '3823',
  '3831',
  '3832',
  '3833',
  '3900',
  '4100',
  '4211',
  '4212',
  '4213',
  '4221',
  '4222',
  '4291',
  '4299',
  '4311',
  '4312',
  '4313',
  '4321',
  '4322',
  '4323',
  '4324',
  '4331',
  '4332',
  '4333',
  '4334',
  '4335',
  '4341',
  '4342',
  '4350',
  '4360',
  '4391',
  '4399',
  '4611',
  '4612',
  '4613',
  '4614',
  '4615',
  '4616',
  '4617',
  '4618',
  '4619',
  '4621',
  '4622',
  '4623',
  '4624',
  '4631',
  '4632',
  '4633',
  '4634',
  '4635',
  '4636',
  '4637',
  '4638',
  '4639',
  '4641',
  '4642',
  '4643',
  '4644',
  '4645',
  '4646',
  '4647',
  '4648',
  '4649',
  '4650',
  '4661',
  '4662',
  '4663',
  '4664',
  '4671',
  '4672',
  '4673',
  '4681',
  '4682',
  '4683',
  '4684',
  '4685',
  '4686',
  '4687',
  '4689',
  '4690',
  '4711',
  '4712',
  '4721',
  '4722',
  '4723',
  '4724',
  '4725',
  '4726',
  '4727',
  '4730',
  '4740',
  '4751',
  '4752',
  '4753',
  '4754',
  '4755',
  '4761',
  '4762',
  '4763',
  '4764',
  '4769',
  '4771',
  '4772',
  '4773',
  '4774',
  '4775',
  '4776',
  '4777',
  '4778',
  '4779',
  '4781',
  '4782',
  '4783',
  '4791',
  '4792',
  '4911',
  '4912',
  '4920',
  '4931',
  '4932',
  '4933',
  '4934',
  '4939',
  '4941',
  '4942',
  '4950',
  '5010',
  '5020',
  '5030',
  '5040',
  '05100',
  '5110',
  '5121',
  '5122',
  '05200',
  '5210',
  '5221',
  '5222',
  '5223',
  '5224',
  '5225',
  '5226',
  '5231',
  '5232',
  '5310',
  '5320',
  '5330',
  '5510',
  '5520',
  '5530',
  '5540',
  '5590',
  '5611',
  '5612',
  '5621',
  '5622',
  '5630',
  '5640',
  '5811',
  '5812',
  '5813',
  '5819',
  '5821',
  '5829',
  '5911',
  '5912',
  '5913',
  '5914',
  '5920',
  '6010',
  '6020',
  '6031',
  '6039',
  '06100',
  '6110',
  '6120',
  '6190',
  '06200',
  '6210',
  '6220',
  '6290',
  '6310',
  '6391',
  '6392',
  '6411',
  '6419',
  '6421',
  '6422',
  '6431',
  '6432',
  '6491',
  '6492',
  '6499',
  '6511',
  '6512',
  '6520',
  '6530',
  '6611',
  '6612',
  '6619',
  '6621',
  '6622',
  '6629',
  '6630',
  '6811',
  '6812',
  '6820',
  '6831',
  '6832',
  '6910',
  '6920',
  '7010',
  '7020',
  '07100',
  '7111',
  '7112',
  '7120',
  '7210',
  '07210',
  '7220',
  '07290',
  '7311',
  '7312',
  '7320',
  '7330',
  '7411',
  '7412',
  '7413',
  '7414',
  '7420',
  '7430',
  '7491',
  '7499',
  '7500',
  '7711',
  '7712',
  '7721',
  '7722',
  '7731',
  '7732',
  '7733',
  '7734',
  '7735',
  '7739',
  '7740',
  '7751',
  '7752',
  '7810',
  '7820',
  '7911',
  '7912',
  '7990',
  '8001',
  '8009',
  '8110',
  '08110',
  '08120',
  '8121',
  '8122',
  '8123',
  '8130',
  '8210',
  '8220',
  '8230',
  '8240',
  '8291',
  '8292',
  '8299',
  '8411',
  '8412',
  '8413',
  '8421',
  '8422',
  '8423',
  '8424',
  '8425',
  '8430',
  '8510',
  '8520',
  '8531',
  '8532',
  '8533',
  '8540',
  '8551',
  '8552',
  '8553',
  '8559',
  '8561',
  '8569',
  '8610',
  '8621',
  '8622',
  '8623',
  '8691',
  '8692',
  '8693',
  '8694',
  '8695',
  '8696',
  '8697',
  '8699',
  '8710',
  '8720',
  '8730',
  '8791',
  '8799',
  '8810',
  '8891',
  '8899',
  '08910',
  '08920',
  '08930',
  '08990',
  '9011',
  '9012',
  '9013',
  '9020',
  '9031',
  '9039',
  '09100',
  '9111',
  '9112',
  '9121',
  '9122',
  '9130',
  '9141',
  '9142',
  '9200',
  '9311',
  '9312',
  '9313',
  '9319',
  '9321',
  '9329',
  '9411',
  '9412',
  '9420',
  '9491',
  '9492',
  '9499',
  '9510',
  '9521',
  '9522',
  '9523',
  '9524',
  '9525',
  '9529',
  '9531',
  '9532',
  '9540',
  '9610',
  '9621',
  '9622',
  '9623',
  '9630',
  '9640',
  '9691',
  '9699',
  '9700',
  '9810',
  '9820',
  '9900',
  '09900',
  '10110',
  '10120',
  '10130',
  '10200',
  '10310',
  '10320',
  '10390',
  '10411',
  '10412',
  '10413',
  '10420',
  '10511',
  '10512',
  '10520',
  '10611',
  '10612',
  '10619',
  '10620',
  '10711',
  '10712',
  '10720',
  '10730',
  '10810',
  '10820',
  '10830',
  '10840',
  '10850',
  '10860',
  '10890',
  '10910',
  '10920',
  '11010',
  '11021',
  '11022',
  '11030',
  '11040',
  '11050',
  '11060',
  '11070',
  '011100',
  '011200',
  '011311',
  '011312',
  '011313',
  '011320',
  '011330',
  '011400',
  '011500',
  '011600',
  '011911',
  '011912',
  '011913',
  '011990',
  '12000',
  '012100',
  '012200',
  '012300',
  '012400',
  '012500',
  '012600',
  '012700',
  '012800',
  '012900',
  '013000',
  '13100',
  '13200',
  '13300',
  '13910',
  '13921',
  '13922',
  '13930',
  '13940',
  '13950',
  '13960',
  '13991',
  '13999',
  '014100',
  '14101',
  '14102',
  '014200',
  '14211',
  '14212',
  '14220',
  '14230',
  '14240',
  '14290',
  '014300',
  '014400',
  '014500',
  '014600',
  '014700',
  '014810',
  '014820',
  '014830',
  '014840',
  '014891',
  '014899',
  '015000',
  '15110',
  '15120',
  '15201',
  '15202',
  '16110',
  '016110',
  '16120',
  '016191',
  '016199',
  '016201',
  '016209',
  '16210',
  '16220',
  '16230',
  '16240',
  '16250',
  '16260',
  '16270',
  '16281',
  '16282',
  '16283',
  '016310',
  '016320',
  '017000',
  '17110',
  '17120',
  '17210',
  '17220',
  '17230',
  '17240',
  '17250',
  '18110',
  '18120',
  '18130',
  '18140',
  '18200',
  '19100',
  '19201',
  '19202',
  '19203',
  '19204',
  '19209',
  '20110',
  '20120',
  '20130',
  '20140',
  '20150',
  '20160',
  '20170',
  '20200',
  '20300',
  '20411',
  '20412',
  '20420',
  '20510',
  '20591',
  '20592',
  '20593',
  '20599',
  '20600',
  '021000',
  '21100',
  '21200',
  '022000',
  '22111',
  '22112',
  '22120',
  '22210',
  '22220',
  '22230',
  '22240',
  '22250',
  '22261',
  '22269',
  '023000',
  '23110',
  '23120',
  '23130',
  '23140',
  '23151',
  '23159',
  '23200',
  '23310',
  '23320',
  '23410',
  '23420',
  '23430',
  '23440',
  '23450',
  '23510',
  '23521',
  '23522',
  '23610',
  '23620',
  '23630',
  '23640',
  '23650',
  '23660',
  '23701',
  '23702',
  '23703',
  '23910',
  '23990',
  '024000',
  '24100',
  '24201',
  '24202',
  '24310',
  '24320',
  '24330',
  '24340',
  '24410',
  '24420',
  '24430',
  '24440',
  '24450',
  '24460',
  '24510',
  '24520',
  '24530',
  '24540',
  '25110',
  '25121',
  '25122',
  '25211',
  '25212',
  '25220',
  '25301',
  '25302',
  '25400',
  '25510',
  '25520',
  '25530',
  '25610',
  '25620',
  '25631',
  '25632',
  '25910',
  '25920',
  '25931',
  '25932',
  '25933',
  '25940',
  '25991',
  '25992',
  '25999',
  '26110',
  '26120',
  '26200',
  '26300',
  '26400',
  '26511',
  '26512',
  '26520',
  '26600',
  '26701',
  '26702',
  '26703',
  '27110',
  '27120',
  '27200',
  '27310',
  '27320',
  '27330',
  '27400',
  '27510',
  '27520',
  '27900',
  '28111',
  '28112',
  '28120',
  '28130',
  '28140',
  '28150',
  '28211',
  '28212',
  '28220',
  '28230',
  '28240',
  '28250',
  '28291',
  '28292',
  '28293',
  '28294',
  '28299',
  '28301',
  '28309',
  '28410',
  '28420',
  '28910',
  '28920',
  '28930',
  '28941',
  '28942',
  '28943',
  '28950',
  '28960',
  '28970',
  '28991',
  '28992',
  '28999',
  '29100',
  '29200',
  '29310',
  '29320',
  '30110',
  '30120',
  '30130',
  '30200',
  '30310',
  '30320',
  '30400',
  '30911',
  '30912',
  '30921',
  '30922',
  '30923',
  '30924',
  '30990',
  '31001',
  '31002',
  '31003',
  '031100',
  '031200',
  '032101',
  '032109',
  '32110',
  '32121',
  '32122',
  '32130',
  '32200',
  '032201',
  '032209',
  '32300',
  '32401',
  '32402',
  '32501',
  '32502',
  '32503',
  '32504',
  '32505',
  '32910',
  '32991',
  '32992',
  '32993',
  '32994',
  '32999',
  '033000',
  '33110',
  '33121',
  '33122',
  '33123',
  '33124',
  '33125',
  '33126',
  '33127',
  '33129',
  '33130',
  '33140',
  '33150',
  '33160',
  '33170',
  '33181',
  '33182',
  '33183',
  '33190',
  '33200',
  '35110',
  '35120',
  '35130',
  '35140',
  '35150',
  '35160',
  '35210',
  '35220',
  '35230',
  '35240',
  '35300',
  '35400',
  '36000',
  '37000',
  '38110',
  '38120',
  '38211',
  '38212',
  '38213',
  '38214',
  '38220',
  '38230',
  '38310',
  '38320',
  '38330',
  '39000',
  '41000',
  '42110',
  '42120',
  '42130',
  '42210',
  '42220',
  '42910',
  '42990',
  '43110',
  '43120',
  '43130',
  '43210',
  '43220',
  '43230',
  '43240',
  '43310',
  '43320',
  '43330',
  '43340',
  '43350',
  '43410',
  '43420',
  '43500',
  '43600',
  '43910',
  '43990',
  '46110',
  '46120',
  '46130',
  '46140',
  '46150',
  '46160',
  '46170',
  '46181',
  '46182',
  '46183',
  '46184',
  '46185',
  '46189',
  '46190',
  '46211',
  '46212',
  '46220',
  '46230',
  '46240',
  '46311',
  '46312',
  '46321',
  '46322',
  '46323',
  '46331',
  '46332',
  '46341',
  '46342',
  '46350',
  '46360',
  '46370',
  '46380',
  '46390',
  '46411',
  '46412',
  '46419',
  '46421',
  '46422',
  '46423',
  '46431',
  '46432',
  '46433',
  '46441',
  '46442',
  '46443',
  '46444',
  '46450',
  '46461',
  '46462',
  '46463',
  '46471',
  '46472',
  '46473',
  '46480',
  '46491',
  '46492',
  '46493',
  '46494',
  '46495',
  '46499',
  '46501',
  '46502',
  '46503',
  '46610',
  '46620',
  '46630',
  '46641',
  '46642',
  '46643',
  '46644',
  '46645',
  '46646',
  '46649',
  '46711',
  '46712',
  '46720',
  '46731',
  '46732',
  '46810',
  '46821',
  '46822',
  '46831',
  '46832',
  '46833',
  '46841',
  '46842',
  '46850',
  '46861',
  '46862',
  '46863',
  '46869',
  '46871',
  '46879',
  '46890',
  '46900',
  '47110',
  '47121',
  '47122',
  '47123',
  '47124',
  '47125',
  '47129',
  '47210',
  '47220',
  '47230',
  '47241',
  '47242',
  '47250',
  '47260',
  '47271',
  '47272',
  '47273',
  '47279',
  '47300',
  '47401',
  '47402',
  '47403',
  '47511',
  '47512',
  '47521',
  '47522',
  '47523',
  '47524',
  '47531',
  '47532',
  '47540',
  '47551',
  '47552',
  '47553',
  '47554',
  '47559',
  '47610',
  '47621',
  '47622',
  '47631',
  '47632',
  '47640',
  '47691',
  '47692',
  '47693',
  '47699',
  '47711',
  '47712',
  '47713',
  '47714',
  '47715',
  '47721',
  '47722',
  '47731',
  '47732',
  '47739',
  '47740',
  '47750',
  '47761',
  '47762',
  '47770',
  '47781',
  '47782',
  '47783',
  '47784',
  '47789',
  '47791',
  '47792',
  '47793',
  '47811',
  '47812',
  '47820',
  '47831',
  '47832',
  '47911',
  '47912',
  '47921',
  '47922',
  '47923',
  '49110',
  '49120',
  '49200',
  '49310',
  '49320',
  '49331',
  '49332',
  '49340',
  '49390',
  '49410',
  '49420',
  '49501',
  '49502',
  '50100',
  '50200',
  '50300',
  '50400',
  '051000',
  '51101',
  '51102',
  '51210',
  '51220',
  '052000',
  '52101',
  '52102',
  '52211',
  '52212',
  '52213',
  '52214',
  '52215',
  '52216',
  '52219',
  '52220',
  '52230',
  '52241',
  '52242',
  '52243',
  '52244',
  '52250',
  '52260',
  '52310',
  '52320',
  '53100',
  '53200',
  '53300',
  '55100',
  '55201',
  '55202',
  '55203',
  '55204',
  '55205',
  '55300',
  '55400',
  '55900',
  '56111',
  '56112',
  '56119',
  '56120',
  '56210',
  '56220',
  '56300',
  '56400',
  '58110',
  '58120',
  '58130',
  '58190',
  '58210',
  '58290',
  '59110',
  '59120',
  '59130',
  '59140',
  '59201',
  '59202',
  '60100',
  '60200',
  '60310',
  '60390',
  '061000',
  '61100',
  '61200',
  '61901',
  '61902',
  '61909',
  '062000',
  '62100',
  '62201',
  '62202',
  '62900',
  '63101',
  '63102',
  '63910',
  '63920',
  '64110',
  '64191',
  '64192',
  '64193',
  '64210',
  '64220',
  '64310',
  '64320',
  '64910',
  '64921',
  '64929',
  '64990',
  '65110',
  '65120',
  '65200',
  '65300',
  '66110',
  '66120',
  '66191',
  '66192',
  '66199',
  '66210',
  '66220',
  '66290',
  '66300',
  '68110',
  '68120',
  '68200',
  '68310',
  '68320',
  '69101',
  '69102',
  '69103',
  '69200',
  '70100',
  '70200',
  '071000',
  '71110',
  '71121',
  '71122',
  '71123',
  '71124',
  '71125',
  '71201',
  '71202',
  '072100',
  '72101',
  '72102',
  '72200',
  '072900',
  '73110',
  '73120',
  '73200',
  '73300',
  '74111',
  '74112',
  '74120',
  '74130',
  '74140',
  '74201',
  '74202',
  '74300',
  '74910',
  '74991',
  '74992',
  '74993',
  '74994',
  '74999',
  '75000',
  '77110',
  '77120',
  '77210',
  '77221',
  '77229',
  '77310',
  '77320',
  '77330',
  '77340',
  '77350',
  '77391',
  '77399',
  '77400',
  '77510',
  '77520',
  '78100',
  '78200',
  '79110',
  '79120',
  '79900',
  '80011',
  '80012',
  '80090',
  '81100',
  '081100',
  '081200',
  '81210',
  '81220',
  '81231',
  '81239',
  '81300',
  '82100',
  '82200',
  '82300',
  '82400',
  '82911',
  '82912',
  '82921',
  '82922',
  '82991',
  '82999',
  '84111',
  '84112',
  '84113',
  '84121',
  '84122',
  '84123',
  '84124',
  '84131',
  '84132',
  '84133',
  '84134',
  '84135',
  '84136',
  '84139',
  '84210',
  '84220',
  '84230',
  '84241',
  '84242',
  '84250',
  '84300',
  '85100',
  '85200',
  '85311',
  '85312',
  '85320',
  '85330',
  '85401',
  '85402',
  '85510',
  '85520',
  '85530',
  '85591',
  '85592',
  '85593',
  '85599',
  '85610',
  '85690',
  '86100',
  '86210',
  '86220',
  '86230',
  '86910',
  '86920',
  '86930',
  '86940',
  '86950',
  '86960',
  '86970',
  '86990',
  '87100',
  '87200',
  '87300',
  '87910',
  '87990',
  '88100',
  '88910',
  '88990',
  '089100',
  '089200',
  '089301',
  '089302',
  '089303',
  '089901',
  '089909',
  '90110',
  '90120',
  '90130',
  '90200',
  '90310',
  '90390',
  '091000',
  '91110',
  '91120',
  '91210',
  '91220',
  '91300',
  '91410',
  '91420',
  '92000',
  '93111',
  '93119',
  '93120',
  '93130',
  '93191',
  '93199',
  '93210',
  '93291',
  '93292',
  '93293',
  '93299',
  '94110',
  '94121',
  '94122',
  '94200',
  '94910',
  '94920',
  '94991',
  '94992',
  '94993',
  '94994',
  '94995',
  '94996',
  '94999',
  '95101',
  '95102',
  '95210',
  '95220',
  '95230',
  '95240',
  '95250',
  '95291',
  '95292',
  '95293',
  '95299',
  '95311',
  '95312',
  '95313',
  '95319',
  '95320',
  '95400',
  '96101',
  '96102',
  '96210',
  '96220',
  '96231',
  '96239',
  '96300',
  '96400',
  '96910',
  '96991',
  '96999',
  '97001',
  '97009',
  '98100',
  '98200',
  '99000',
  '099000',
  '101100',
  '101200',
  '101300',
  '102001',
  '102009',
  '103100',
  '103200',
  '103900',
  '104110',
  '104120',
  '104130',
  '104200',
  '105110',
  '105120',
  '105200',
  '106111',
  '106119',
  '106120',
  '106190',
  '106200',
  '107110',
  '107120',
  '107200',
  '107301',
  '107302',
  '108100',
  '108200',
  '108301',
  '108302',
  '108400',
  '108501',
  '108502',
  '108503',
  '108504',
  '108505',
  '108509',
  '108600',
  '108901',
  '108909',
  '109100',
  '109200',
  '110100',
  '110210',
  '110220',
  '110300',
  '110400',
  '110500',
  '110600',
  '110701',
  '110702',
  '120000',
  '131000',
  '132000',
  '133000',
  '139100',
  '139210',
  '139220',
  '139300',
  '139400',
  '139500',
  '139600',
  '139910',
  '139990',
  '141010',
  '141020',
  '142110',
  '142120',
  '142200',
  '142300',
  '142400',
  '142900',
  '151100',
  '151200',
  '152010',
  '152020',
  '161100',
  '161200',
  '162100',
  '162200',
  '162301',
  '162309',
  '162400',
  '162500',
  '162600',
  '162700',
  '162811',
  '162819',
  '162820',
  '162830',
  '171100',
  '171200',
  '172100',
  '172200',
  '172301',
  '172309',
  '172400',
  '172500',
  '181100',
  '181200',
  '181300',
  '181400',
  '182000',
  '191000',
  '192010',
  '192020',
  '192030',
  '192040',
  '192090',
  '201100',
  '201200',
  '201300',
  '201400',
  '201500',
  '201600',
  '201700',
  '202000',
  '203000',
  '204110',
  '204120',
  '204200',
  '205100',
  '205911',
  '205912',
  '205920',
  '205930',
  '205991',
  '205999',
  '206000',
  '211000',
  '212001',
  '212009',
  '221110',
  '221120',
  '221200',
  '222100',
  '222200',
  '222300',
  '222401',
  '222409',
  '222500',
  '222611',
  '222612',
  '222691',
  '222699',
  '231100',
  '231200',
  '231300',
  '231400',
  '231510',
  '231590',
  '232000',
  '233100',
  '233200',
  '234100',
  '234200',
  '234300',
  '234400',
  '234500',
  '235100',
  '235210',
  '235220',
  '236101',
  '236102',
  '236103',
  '236104',
  '236109',
  '236200',
  '236300',
  '236400',
  '236501',
  '236502',
  '236601',
  '236609',
  '237010',
  '237020',
  '237030',
  '239100',
  '239900',
  '241000',
  '242010',
  '242020',
  '243100',
  '243200',
  '243301',
  '243302',
  '243303',
  '243400',
  '244100',
  '244200',
  '244300',
  '244400',
  '244500',
  '244600',
  '245101',
  '245102',
  '245109',
  '245200',
  '245301',
  '245302',
  '245303',
  '245309',
  '245401',
  '245402',
  '245403',
  '245409',
  '251100',
  '251210',
  '251220',
  '252110',
  '252120',
  '252200',
  '253010',
  '253020',
  '254000',
  '255100',
  '255200',
  '255300',
  '256100',
  '256200',
  '256311',
  '256312',
  '256320',
  '259100',
  '259200',
  '259310',
  '259320',
  '259330',
  '259400',
  '259910',
  '259920',
  '259990',
  '261100',
  '261200',
  '262000',
  '263001',
  '263009',
  '264001',
  '264009',
  '265110',
  '265121',
  '265129',
  '265200',
  '266001',
  '266002',
  '267011',
  '267012',
  '267020',
  '267030',
  '271100',
  '271200',
  '272000',
  '273100',
  '273200',
  '273300',
  '274001',
  '274002',
  '274009',
  '275100',
  '275200',
  '279001',
  '279002',
  '279003',
  '279004',
  '279009',
  '281110',
  '281120',
  '281200',
  '281300',
  '281400',
  '281500',
  '282110',
  '282120',
  '282201',
  '282209',
  '282300',
  '282400',
  '282500',
  '282910',
  '282920',
  '282930',
  '282941',
  '282949',
  '282991',
  '282992',
  '282999',
  '283010',
  '283091',
  '283099',
  '284100',
  '284200',
  '289100',
  '289200',
  '289300',
  '289410',
  '289420',
  '289430',
  '289500',
  '289600',
  '289701',
  '289702',
  '289709',
  '289910',
  '289920',
  '289991',
  '289992',
  '289993',
  '289999',
  '291000',
  '292000',
  '293100',
  '293200',
  '301100',
  '301200',
  '301300',
  '302000',
  '303100',
  '303200',
  '304000',
  '309111',
  '309112',
  '309120',
  '309210',
  '309220',
  '309230',
  '309240',
  '309900',
  '310011',
  '310012',
  '310013',
  '310014',
  '310015',
  '310020',
  '310031',
  '310032',
  '310033',
  '310034',
  '310035',
  '310036',
  '310037',
  '310039',
  '321100',
  '321210',
  '321220',
  '321300',
  '322000',
  '323001',
  '323009',
  '324010',
  '324020',
  '325010',
  '325020',
  '325030',
  '325040',
  '325051',
  '325052',
  '325053',
  '329100',
  '329910',
  '329920',
  '329930',
  '329940',
  '329991',
  '329999',
  '331101',
  '331102',
  '331103',
  '331104',
  '331105',
  '331106',
  '331109',
  '331210',
  '331220',
  '331230',
  '331240',
  '331251',
  '331252',
  '331253',
  '331254',
  '331259',
  '331260',
  '331270',
  '331291',
  '331292',
  '331299',
  '331301',
  '331302',
  '331309',
  '331400',
  '331500',
  '331600',
  '331700',
  '331810',
  '331820',
  '331830',
  '331900',
  '332001',
  '332002',
  '332003',
  '332004',
  '332005',
  '332006',
  '332007',
  '332009',
  '351100',
  '351200',
  '351300',
  '351400',
  '351500',
  '351600',
  '352100',
  '352200',
  '352300',
  '352400',
  '353000',
  '354000',
  '360000',
  '370000',
  '381100',
  '381200',
  '382111',
  '382112',
  '382120',
  '382130',
  '382140',
  '382200',
  '382300',
  '383100',
  '383200',
  '383300',
  '390001',
  '390009',
  '410000',
  '421100',
  '421200',
  '421300',
  '422100',
  '422200',
  '429100',
  '429900',
  '431100',
  '431201',
  '431209',
  '431300',
  '432101',
  '432102',
  '432103',
  '432104',
  '432105',
  '432201',
  '432202',
  '432203',
  '432204',
  '432205',
  '432206',
  '432207',
  '432300',
  '432401',
  '432402',
  '432409',
  '433101',
  '433102',
  '433201',
  '433202',
  '433300',
  '433401',
  '433402',
  '433500',
  '434100',
  '434200',
  '435000',
  '436000',
  '439100',
  '439901',
  '439902',
  '439909',
  '461101',
  '461102',
  '461103',
  '461104',
  '461201',
  '461202',
  '461203',
  '461204',
  '461205',
  '461301',
  '461302',
  '461303',
  '461401',
  '461402',
  '461403',
  '461404',
  '461405',
  '461501',
  '461502',
  '461503',
  '461504',
  '461505',
  '461601',
  '461602',
  '461603',
  '461604',
  '461605',
  '461606',
  '461607',
  '461701',
  '461702',
  '461703',
  '461704',
  '461705',
  '461706',
  '461707',
  '461811',
  '461812',
  '461813',
  '461814',
  '461821',
  '461822',
  '461823',
  '461824',
  '461825',
  '461826',
  '461831',
  '461832',
  '461833',
  '461841',
  '461842',
  '461843',
  '461844',
  '461845',
  '461846',
  '461850',
  '461891',
  '461892',
  '461893',
  '461899',
  '461900',
  '462110',
  '462121',
  '462122',
  '462200',
  '462300',
  '462401',
  '462402',
  '463110',
  '463120',
  '463211',
  '463212',
  '463220',
  '463231',
  '463232',
  '463310',
  '463320',
  '463410',
  '463420',
  '463501',
  '463509',
  '463600',
  '463701',
  '463702',
  '463800',
  '463900',
  '464110',
  '464120',
  '464190',
  '464210',
  '464220',
  '464230',
  '464310',
  '464320',
  '464330',
  '464410',
  '464420',
  '464430',
  '464440',
  '464500',
  '464610',
  '464620',
  '464631',
  '464639',
  '464710',
  '464720',
  '464730',
  '464800',
  '464910',
  '464921',
  '464922',
  '464930',
  '464941',
  '464949',
  '464950',
  '464991',
  '464992',
  '464999',
  '465010',
  '465020',
  '465030',
  '466100',
  '466200',
  '466300',
  '466411',
  '466419',
  '466420',
  '466430',
  '466440',
  '466451',
  '466459',
  '466460',
  '466491',
  '466492',
  '466499',
  '467110',
  '467120',
  '467200',
  '467310',
  '467320',
  '468100',
  '468210',
  '468221',
  '468229',
  '468310',
  '468321',
  '468322',
  '468323',
  '468329',
  '468330',
  '468410',
  '468420',
  '468501',
  '468502',
  '468509',
  '468610',
  '468620',
  '468630',
  '468690',
  '468710',
  '468790',
  '468900',
  '469000',
  '471101',
  '471102',
  '471210',
  '471220',
  '471230',
  '471240',
  '471250',
  '471290',
  '472101',
  '472102',
  '472200',
  '472300',
  '472410',
  '472420',
  '472500',
  '472601',
  '472602',
  '472609',
  '472710',
  '472720',
  '472730',
  '472790',
  '473000',
  '474010',
  '474020',
  '474030',
  '475110',
  '475120',
  '475210',
  '475220',
  '475231',
  '475232',
  '475240',
  '475311',
  '475312',
  '475320',
  '475400',
  '475510',
  '475520',
  '475530',
  '475540',
  '475590',
  '476100',
  '476210',
  '476220',
  '476310',
  '476321',
  '476329',
  '476400',
  '476911',
  '476912',
  '476920',
  '476930',
  '476991',
  '476999',
  '477110',
  '477120',
  '477130',
  '477140',
  '477150',
  '477211',
  '477212',
  '477220',
  '477310',
  '477320',
  '477390',
  '477401',
  '477409',
  '477500',
  '477610',
  '477620',
  '477700',
  '477810',
  '477821',
  '477822',
  '477823',
  '477824',
  '477825',
  '477830',
  '477840',
  '477891',
  '477892',
  '477893',
  '477899',
  '477910',
  '477920',
  '477931',
  '477932',
  '477939',
  '478110',
  '478120',
  '478200',
  '478310',
  '478320',
  '479110',
  '479120',
  '479210',
  '479221',
  '479222',
  '479229',
  '479231',
  '479232',
  '479233',
  '479234',
  '479235',
  '479236',
  '479239',
  '491100',
  '491200',
  '492000',
  '493101',
  '493102',
  '493201',
  '493202',
  '493310',
  '493320',
  '493400',
  '493900',
  '494100',
  '494200',
  '495010',
  '495020',
  '501000',
  '502000',
  '503000',
  '504000',
  '511010',
  '511020',
  '512100',
  '512200',
  '521010',
  '521020',
  '522110',
  '522120',
  '522130',
  '522140',
  '522150',
  '522160',
  '522190',
  '522201',
  '522209',
  '522300',
  '522410',
  '522420',
  '522430',
  '522440',
  '522501',
  '522509',
  '522601',
  '522602',
  '523100',
  '523200',
  '531000',
  '532000',
  '533000',
  '551000',
  '552010',
  '552020',
  '552031',
  '552032',
  '552041',
  '552042',
  '552051',
  '552052',
  '553001',
  '553002',
  '553003',
  '553004',
  '554000',
  '559000',
  '561111',
  '561112',
  '561121',
  '561122',
  '561123',
  '561124',
  '561191',
  '561192',
  '561193',
  '561201',
  '561202',
  '561203',
  '562101',
  '562102',
  '562201',
  '562202',
  '563001',
  '563002',
  '563003',
  '563004',
  '564000',
  '581100',
  '581200',
  '581300',
  '581900',
  '582100',
  '582900',
  '591100',
  '591200',
  '591300',
  '591400',
  '592010',
  '592020',
  '601000',
  '602000',
  '603100',
  '603900',
  '611001',
  '611002',
  '611003',
  '612000',
  '619010',
  '619020',
  '619090',
  '621000',
  '622010',
  '622020',
  '629001',
  '629009',
  '631010',
  '631021',
  '631029',
  '639100',
  '639200',
  '641100',
  '641910',
  '641920',
  '641930',
  '642100',
  '642200',
  '643100',
  '643200',
  '649100',
  '649210',
  '649291',
  '649299',
  '649900',
  '651100',
  '651200',
  '652000',
  '653000',
  '661100',
  '661200',
  '661910',
  '661921',
  '661922',
  '661990',
  '662100',
  '662200',
  '662901',
  '662909',
  '663001',
  '663002',
  '663003',
  '681100',
  '681200',
  '682001',
  '682002',
  '682009',
  '683100',
  '683201',
  '683209',
  '691010',
  '691020',
  '691030',
  '692001',
  '692002',
  '692003',
  '692004',
  '692005',
  '692006',
  '692007',
  '701000',
  '702001',
  '702002',
  '702009',
  '711101',
  '711109',
  '711210',
  '711220',
  '711230',
  '711240',
  '711250',
  '712011',
  '712019',
  '712021',
  '712022',
  '712029',
  '721010',
  '721021',
  '721022',
  '721029',
  '722001',
  '722009',
  '731101',
  '731102',
  '731103',
  '731200',
  '732000',
  '733001',
  '733002',
  '733003',
  '733009',
  '741110',
  '741120',
  '741201',
  '741209',
  '741300',
  '741401',
  '741409',
  '742011',
  '742012',
  '742019',
  '742020',
  '743000',
  '749100',
  '749911',
  '749912',
  '749913',
  '749914',
  '749915',
  '749916',
  '749919',
  '749921',
  '749929',
  '749931',
  '749932',
  '749933',
  '749941',
  '749942',
  '749991',
  '749992',
  '749993',
  '749994',
  '749999',
  '750000',
  '771100',
  '771200',
  '772101',
  '772102',
  '772109',
  '772210',
  '772290',
  '773100',
  '773200',
  '773300',
  '773400',
  '773500',
  '773910',
  '773991',
  '773992',
  '773999',
  '774000',
  '775100',
  '775200',
  '781000',
  '782000',
  '791100',
  '791200',
  '799001',
  '799002',
  '799003',
  '799004',
  '800111',
  '800112',
  '800113',
  '800114',
  '800121',
  '800129',
  '800900',
  '811000',
  '812100',
  '812201',
  '812209',
  '812310',
  '812391',
  '812399',
  '813000',
  '821000',
  '822000',
  '823001',
  '823002',
  '823003',
  '823004',
  '823009',
  '824001',
  '824009',
  '829110',
  '829120',
  '829210',
  '829220',
  '829911',
  '829919',
  '829991',
  '829999',
  '841110',
  '841120',
  '841130',
  '841210',
  '841220',
  '841230',
  '841240',
  '841310',
  '841320',
  '841330',
  '841340',
  '841350',
  '841360',
  '841390',
  '842100',
  '842200',
  '842300',
  '842410',
  '842420',
  '842500',
  '843000',
  '851000',
  '852000',
  '853110',
  '853120',
  '853201',
  '853202',
  '853203',
  '853209',
  '853300',
  '854010',
  '854020',
  '855101',
  '855109',
  '855201',
  '855202',
  '855209',
  '855300',
  '855910',
  '855920',
  '855930',
  '855991',
  '855999',
  '856100',
  '856901',
  '856909',
  '861000',
  '862100',
  '862201',
  '862202',
  '862203',
  '862300',
  '869101',
  '869102',
  '869200',
  '869300',
  '869401',
  '869402',
  '869500',
  '869601',
  '869609',
  '869700',
  '869901',
  '869902',
  '869903',
  '869909',
  '871000',
  '872000',
  '873000',
  '879100',
  '879900',
  '881000',
  '889100',
  '889901',
  '889902',
  '889903',
  '889904',
  '889909',
  '901101',
  '901102',
  '901109',
  '901200',
  '901300',
  '902001',
  '902009',
  '903100',
  '903901',
  '903909',
  '911100',
  '911200',
  '912100',
  '912200',
  '913001',
  '913002',
  '913009',
  '914100',
  '914200',
  '920001',
  '920009',
  '931110',
  '931190',
  '931200',
  '931301',
  '931309',
  '931910',
  '931991',
  '931992',
  '931993',
  '931999',
  '932100',
  '932910',
  '932920',
  '932930',
  '932991',
  '932999',
  '941100',
  '941210',
  '941220',
  '942000',
  '949100',
  '949200',
  '949910',
  '949920',
  '949930',
  '949940',
  '949950',
  '949960',
  '949990',
  '951010',
  '951021',
  '951029',
  '952100',
  '952201',
  '952202',
  '952300',
  '952401',
  '952409',
  '952500',
  '952910',
  '952921',
  '952922',
  '952930',
  '952991',
  '952999',
  '953110',
  '953120',
  '953130',
  '953191',
  '953192',
  '953199',
  '953200',
  '954000',
  '961011',
  '961012',
  '961021',
  '961022',
  '962100',
  '962201',
  '962209',
  '962310',
  '962391',
  '962399',
  '963001',
  '963002',
  '963009',
  '964000',
  '969100',
  '969911',
  '969912',
  '969913',
  '969914',
  '969919',
  '969991',
  '969992',
  '969993',
  '969994',
  '969999',
  '970010',
  '970090',
  '981000',
  '982000',
  '990000',
]);

export function isSupportedAtecoCode(code: string | null | undefined): boolean {
  return !code || validAtecoCodesSet.has(code);
}
